import React from 'react'
import { useSearchContext } from '../../../context/search.context'
import '../../search-header/SearchHeader.scss'
import { currentLang, handleKeyDown, highlightText, isLight, placeholder } from '../../../Common'
import { clickSuggestionItem } from '../../../datalayerEvent'

const SearchHeader = (props: serachHeaderProps) => {
  // const [isShowSearch, setIsShowSearch] = React.useState(true)
  // const [heightFromTop, setHeightFromTop] = React.useState('0px')
  const { handleSubmit, setSearchValue, searchValue, searchData, page } = useSearchContext()

  const queryParam = new URLSearchParams(window?.location?.search).get('q')

  return (
    <>
      <div className={`search-result__page search-header ${!isLight && 'search-header--inverted'}`}>
        <div className='container'>
          <form onSubmit={handleSubmit}>
            <div className='search-header__form-wrapper'>
              <div className='search-header__control'>
                <i className='icons search search-header__icon-search'></i>
                <input
                  id='search_result'
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, searchValue, searchData)}
                  type='text'
                  placeholder={placeholder}
                />
                <button onClick={() => setSearchValue('')} className='search-header__close'>
                  <i className='icons close'></i>
                </button>
              </div>
            </div>
          </form>

          <div className='search-container'>
            {searchValue &&
            searchData?.hits?.total?.value &&
            (window?.location?.pathname.includes('/search-result')
              ? queryParam !== searchValue
              : true) ? (
              <div className='search-header__results'>
                <ul className='search-header__result-lists'>
                  {searchData?.hits?.hits?.slice(0, 5).map((item) => (
                    <li
                      key={item._id}
                      onClick={() => clickSuggestionItem(item?._source?.title?.[0])}
                    >
                      <a href={`${currentLang}/search-result?q=${item._source.title?.[0]}`}>
                        {highlightText(item?._source?.title?.[0], searchValue)}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}

            {searchValue &&
            searchData?.hits?.total?.value &&
            props?.showCountVisible &&
            queryParam === searchValue ? (
              <div className='search-header__results'>
                <div className='search-header-records'>
                  {searchData?.hits?.hits.length > 9 && (
                    <>
                      {' '}
                      {10 * page - 10 === 0 ? 1 : 10 * page - 10}-{10 * page} of{' '}
                    </>
                  )}
                  {searchData?.hits?.total?.value} results for <span>‘{searchValue}’</span>
                </div>
              </div>
            ) : null}

            {searchData?.hits?.hits?.length === 0 ? (
              <div className='search-header__results'>
                <div className='search-header-records'>
                  <div>Your search did not match any results.</div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {/* <div className='search-overlay'></div> */}
    </>
  )
}

export default SearchHeader
